<template>
	<div class="page_content explore_entity_inside program career" aria-label="program guide careers">

		<div class="row page-heading">
			<div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 input module_heading">
        <span class="module_icon  icon-list"></span>
        <label v-if="formattedProgramGuide && formattedProgramGuide.title" id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="'Program ' + formattedProgramGuide.title">
          Program: {{formattedProgramGuide.title}}
        </label>
        <label v-else id="programGuideTitle" class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="'Program ' + formattedCareer.name">Program: {{formattedCareer.name}}</label>

				<b-popover target="programGuideTitle" triggers="hover" placement="top" class="title_popup" container="entityNameContainer">
					<div class="title_container">
					  <template v-if="formattedProgramGuide && formattedProgramGuide.title">
							Program: {{formattedProgramGuide.title}}
						</template>
						<template v-else>
							Program: {{formattedCareer.name}}
						</template>
					</div>
				</b-popover>
				<div id="entityNameContainer" class="title_container_popup"></div>
  		</div>

  		<template v-if="isWidget">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 btn_container" :id="'creditProgressPopup_' + programGuide.uuid">
          <b-btn style="width: 225px; padding: 0;" @click="calculateCreditProgressClicked(programGuide)">
            <b-progress :max="progress.total" height="30px" style="cursor: pointer;" show-value>
              <b-progress-bar :value="Number(selected)" style="background-color: #532a6e;"></b-progress-bar>
              <b-progress-bar :value="progress.completed" style="background-color: #508002;"></b-progress-bar>
              <b-progress-bar :value="progress.notPlanned - selected" style="background-color: #cf7908;"></b-progress-bar>
            </b-progress>
          </b-btn>
        </div>
      </template>
      <template v-else>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
      		<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
            <span class="btn_ic ic-back"></span>
            <span class="btn_txt"> {{ deCamelCase() }} </span>
          </b-btn>
          <span v-if="showAddCompletedCoursesOnResult">
            <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
          </span>
          <span class="lnk_req_credit"
            v-if="showCalculateRequiredCredit && isStudentLogin && planningStream" :id="'creditProgressPopup_' + programGuide.uuid"
            @click="calculateCreditProgressClicked(programGuide)">
            <template v-if="isShowCourseProgressEnabled">
              <template v-if="showTransferredCoursesCreditProgress">
                <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                  <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transferredCourses}} out of {{progress.totalCourses}} courses</span>
                </div>
              </template>
              <template v-else>
                <b-btn style="width: 225px; padding: 0;">
                  <b-progress :max="progress.totalCourses" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                    <b-progress-bar :value="progress.transferredCourses" :precision="setPrecision(progress.transferredCourses)" style="background-color: #57b6e6;"></b-progress-bar>
                    <b-progress-bar :value="progress.completedCourses" :precision="setPrecision(progress.completedCourses)" style="background-color: #508002;"></b-progress-bar>
                    <b-progress-bar :value="progress.inProgressCourses" :precision="setPrecision(progress.inProgressCourses)" style="background-color: #9ec758;"></b-progress-bar>
                    <b-progress-bar :value="progress.notStartedCourses" :precision="setPrecision(progress.notStartedCourses)" style="background-color: #f5b318;"></b-progress-bar>
                    <b-progress-bar :value="progress.notPlannedCourses" :precision="setPrecision(progress.notPlannedCourses)" style="background-color: #cf7908;"></b-progress-bar>
                  </b-progress>
                </b-btn>
              </template>
            </template>
            <template v-else>
              <template v-if="showTransferredCoursesCreditProgress">
                <div style="border: 1px solid #157099; margin: -3px -15px; font-size: 18px;">
                  <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transfered}} out of {{progress.total}} credits</span>
                </div>
              </template>
              <template v-else>
                <b-btn style="width: 225px; padding: 0;">
                  <b-progress :max="progress.total" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                    <b-progress-bar :value="progress.transfered" :precision="setPrecision(progress.transfered)" style="background-color: #57b6e6;"></b-progress-bar>
                    <b-progress-bar :value="progress.completed" :precision="setPrecision(progress.completed)" style="background-color: #508002;"></b-progress-bar>
                    <b-progress-bar :value="progress.inProgress" :precision="setPrecision(progress.inProgress)" style="background-color: #9ec758;"></b-progress-bar>
                    <b-progress-bar :value="progress.notStarted" :precision="setPrecision(progress.notStarted)" style="background-color: #f5b318;"></b-progress-bar>
                    <b-progress-bar :value="progress.notPlanned" :precision="setPrecision(progress.notPlanned)" style="background-color: #cf7908;"></b-progress-bar>
                  </b-progress>
                </b-btn>
              </template>
            </template>
          </span>
    		</div>
      </template>
    </div>


    	<div class="page_content_container">

    		<div v-if="formattedProgramGuide && formattedProgramGuide.title">
	    		<program-guide-menu
	          		:cipCode="formattedProgramGuide.cipCode"
	          		:programGuideCode="formattedProgramGuide.code"
	          		:type="formattedProgramGuide.type"
	          		:returnTo="returnTo"
	          		:active="'careers'"
                :isWidget="isWidget"
                :selected="selected">
	      		</program-guide-menu>
      		</div>

					<div class="row pg_content list_view">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

							<template v-if="formattedCareers && formattedCareers.length > 0">
								<div class="row result_row" v-for="(career, index) in formattedCareers">

										<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section" @click.stop="goToCareerDetail(career)">
											<div class="thumbnail_container ace_sec">
												<div class="thumbnail_img" v-if="career.thumbnailUrl">
													<img v-bind:src="career.thumbnailUrl" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
												</div>
												<div class="thumbnail" v-else>
													<div class="txt_bx" :id="setTitleBoxWidth(career.name, 'thumb_' + index)" v-html="setTitleInitials(career.name)"></div>
												</div>
											</div>
										</div>

										<div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section" :class="updateTitleHeight(index)">
											<div class="row">
												<div class="col-12 title_row">
													<!--
													<span class="icon icon-career"></span>
													-->
													<span class="title ace_sec_txt" :id="'entityName_' + index" @click.stop="goToCareerDetail(career)" :aria-label="career.name">{{career.name}}</span>

													<span
														v-if="isBookmarked(career)"
														@click.stop.prevent="deleteCareerBookmark(career)"
														class="ic_bm_container bookmarked ace_sec_txt"
														title="remove this career from bookmark">
														<span class="icon ic8-bookmark3"></span>
													</span>
													<span
														v-else-if="!isBookmarked(career)"
														@click.stop.prevent="bookmarkCareer(career)"
														class="ic_bm_container ace_sec_txt"
														title="bookmark this career">
														<span class="icon ic8-bookmark3"></span>
													</span>

													<b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
														<div class="title_container">
															{{career.name}}
														</div>
													</b-popover>
													<div :id="'entityNameContainer_' + index" class="title_container_popup"></div>

												</div>

												<div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="career.description">
													 <span class="desc_txt">{{ career.description }}</span>
												</div>
												<div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this career" v-else>
													 No description added for this career
												</div>

											</div>
										</div>


										<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
											<div class="row">
												<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
													<div class="info_title">median income</div>
													<div class="info_val ace_sec_txt" v-if="career.medianHourlyEarning" :aria-label="'median income is ' + career.medianHourlyEarning">
														$<span v-html="addCommaInNumber(career.medianHourlyEarning)"></span>
													</div>
													<div v-else class="info_no_val ace_sec_txt" aria-label="median income is not available for this career">N/A</div>
												</div>

												<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
													<div class="info_title">job postings</div>
													<div v-if="career.annualOpening" class="info_val ace_sec_txt" :aria-label="'job postings are ' + career.annualOpening + ' for this career'">
														<span v-html="addCommaInNumber(career.annualOpening)"></span>
													</div>
													<div v-else class="info_no_val ace_sec_txt" aria-label="job postings are not available for this career">N/A</div>
												</div>

												<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
													<div class="info_title">growth rate</div>
													<div v-if="career.growth" class="info_val ace_sec_txt" :aria-label="'Growth rate is ' + career.growth + ' for this career'">
														<span>{{career.growth}} %</span>
													</div>
													<div v-else class="info_no_val ace_sec_txt empty_pattern" aria-label="growth rate is not available for this career">N/A</div>
												</div>

											</div>
										</div>

									</div>
								</template>

								<template v-else>
									<div class="col-12 hd ace_sec_hd" aria-label="Careers">
										<h2>Careers</h2>
										<span class="hd_bdr"></span>
									</div>
									<div class="msg_no_data empty_pattern ace_sec_txt" aria-label="No career available or configured for this program">
										No career available or configured for this program
									</div>
								</template>

	          	</div> <!-- .content_mid_panel -->
        	</div> <!-- .pg_content -->
          <template v-if="showCreditProgressPopup">
            <explore-program-credit-progress
                :title="selectedProgramGuide.title"
                :stream-id="planningStream.uuid"
                :program-id="selectedProgramGuide.uuid"
                :credit-progress-target-id="creditProgressTargetId"
                :is-widget="isWidget"
                :selected="Number(selected)">
            </explore-program-credit-progress>
          </template>
		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
				</div>
			</b-modal>
		</div>

    <div class="modal_popup_container">
      <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            Create Your Account To Explore More
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="closeModalBox">
            <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-1 lft_col"></div>
          <div class="col-5 content_col">
						<div class="pr-5">
            	<p>Your institution has made the Pragya Explore app available to you for free.</p>
            	<p>Your Data is completely secure. Read our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
              <p v-if="isShowPhoneOnCreateAccountModalEnabled">{{showPhoneOnCreateAccountModalLabel}}</p>
          	</div>
					</div>
          <div class="col-5 content_col">
            <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Password <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="password" v-model.trim="newForm.password" placeholder="Password">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Confirm Password <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="password" v-model.trim="repassword" placeholder="Confirm Password">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="isShowPhoneOnCreateAccountModalEnabled">
              <div class="col-12">
                <div class="fld-label" id="lastName">Phone Number <sup v-if="isPhoneRequiredOnCreateAccountModal">*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">By clicking on Create Account you are accepting our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a> & <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">Terms of Use</a></div>
              </div>
            </div>
            <div class="row popup_btn_container">
              <div class="col-6 pragya_login_lnk">
              </div>
              <div class="col-6 popup_btn">
                <b-button size="lg" @click="registerProspectiveStudent()"aria-label="verify">Create Account</b-button>
              </div>
            </div>
          </div>
          <div class="col-1 rgt_col"></div>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ExploreProgramCreditProgress from '../../explore/components/ExploreProgramCreditProgress'
import VClamp from 'vue-clamp'

export default {
  name: 'program-guide-careers',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'isWidget', 'selected', 'loadDataFromServer'],
  components: {
    ProgramGuideMenu,
    VClamp,
    ExploreProgramCreditProgress
  },
  data: () => {
    return {
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      userId: localStorage.getItem('userid'),
      navigationErrorMessage: 'No SOC data found for this Career. Please re-upload to see more details',
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      progress: {},
      repassword: '',
      newForm: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      },
      newProspectError: '',
      nextPage: {}
    }
  },

  async mounted () {
    await this.loadAllBookmarks()
    await this.loadDataForProgramGuideCareers()
  },

  beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    let tempUser = localStorage.getItem('tempUser')
    if (tempUser && tempUser === 'true') {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: 'Cannot move past this page till account setup is complete'
      })
      this.showNewFormPopup()
      this.nextPage = next
    } else {
      // Navigate to next view
      next()
    }
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'loadAllBookmarks',
      'loadCreateBookmarks',
      'loadDeleteBookmark',
      'loadLogDashboardActivity',
      'loadProgramCreditProgress',
      'loadFinishAccountSetup',
      'setTemporaryUserToFalse'
    ]),
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },
    async registerProspectiveStudent () {
      if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1 || this.newForm.password.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'First Name, Last Name and Password are required'
        })
      } else if (this.newForm.password !== this.repassword) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Passwords do no match'
        })
      } else if (this.isShowPhoneOnCreateAccountModalEnabled && this.isPhoneRequiredOnCreateAccountModal && this.newForm.primaryPhoneNumber.length < 1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Phone Number is required'
        })
      } else {
        this.$refs.loadingModal.show()
        await this.loadFinishAccountSetup(this.newForm)
        let bool = false
        this.setTemporaryUserToFalse()
        this.nextPage()
      }
    },
    showNewFormPopup (popupPosition) {
      this.$refs.newFormModal.show()
      $('.usr_verification_popup').removeClass('showAtTop')
      $('.usr_verification_popup').removeClass('showAtBottom')
      $('.usr_verification_popup').addClass('showAtTop')
    },
    closeModalBox () {
      this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
      this.$parent.isShowTagPopup = false
      this.newForm = {
        firstName: '',
        lastName: '',
        password: '',
        primaryPhoneNumber: ''
      }
    },
    async loadDataForProgramGuideCareers () {
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      let programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true
      })
      if (!programGuide || !programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      // load credit progress
      this.progress = await this.loadProgramCreditProgress({streamId: this.planningStream.uuid, programId: programGuide.uuid, recalculate: false})
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: programGuide.cipCode, code: programGuide.code, showAllOccupations: true })
      this.loadLogDashboardActivity({action: 'viewProgramCareers', page: 'programCareers', link: '', programCipCode: cipCode})
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    goToCareerDetail (career) {
      if (!career.code) {
        return this.notifyFailure(this.navigationErrorMessage)
      }
      let routerParams = {
        code: career.pragyaSoc,
        cipCode: this.cipCode,
        returnTo: 'programGuideCareers',
        showBackToResultButton: false
      }
      return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'programGuideCareers'} })
    },
    getCareerBookmark (career) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === career.uuid) {
          target = bookmark
        }
      })
      return target
    },
    isBookmarked (career) {
      return career.bookmark && career.bookmark.uuid
    },
    setTitleInitials (entityTitle) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    setTitleBoxWidth (entityTitle, entityId) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      if (getTitleInitials.length < 3) {
        $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
      }
      return entityId
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    addCommaInNumber (numValue) {
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    },
    async bookmarkCareer (career) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'career',
        'entityTitle': career.name,
        'entityUuid': career.uuid,
        // 'institutionId': career.institutionId,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + career.name + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },
    async deleteCareerBookmark (career) {
      await this.loadDeleteBookmark(career.bookmark.uuid)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Career as bookmarked
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    getThumbnailURI (code) {
      return 'https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/soc-' + code + '---00.svg'
    }
  },
  computed: {
    ...mapState({
      'programGuide': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'packages': state => state.institution.packages,
      'institution': state => state.institution.institution,
      'bookmarks': state => state.explore.bookmarks,
      'planningStream': state => state.dashboard.planningStream,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'termMapWithCutOffDate': state => state.institution.termMapWithCutOffDate
    }),
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuide
      return formattedProgramGuide
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      let getBookmark = this.getCareerBookmark
      careers.targetOccupations.forEach((careerObj) => {
        let career = JSON.parse(careerObj)
        career.bookmark = getBookmark(career)
        if (!career.thumbnailUrl) {
          career.thumbnailUrl = this.getThumbnailURI(career.code)
        }
        formattedCareers.push(career)
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    showTransferredCoursesCreditProgress () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesCreditProgress') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showCalculateRequiredCredit () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    },
    showPhoneNumberOnWidgetIsEnabled () {
      let phoneNumberFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_WIDGET]
      return phoneNumberFeature && phoneNumberFeature.enabled
    },
    availableTerms () {
      let terms = []
      let entries = Object.entries(this.termMapWithCutOffDate)
      if (entries && entries.length > 0) {
        terms.push({value: null, text: 'Select a Term'})
        for (const [key, data] of entries) {
          if (key) {
            terms.push({value: key, text: data.label})
          }
        }
        return terms
      }
      return []
    },
    showTermOnWidgetIsEnabled () {
      let termFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_TERM_ON_WIDGET]
      return termFeature && termFeature.enabled
    },
    showPhoneOnCreateAccountModalLabel () {
      let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
      return showPhoneFeature.label
    },
    isShowPhoneOnCreateAccountModalEnabled () {
      let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
      return showPhoneFeature && showPhoneFeature.enabled
    },
    isPhoneRequiredOnCreateAccountModal () {
      let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
      for (var i = 0; i < showPhoneFeature.flags.length; i++) {
        if (showPhoneFeature.flags[i].title === 'phoneNumberRequired') {
          return showPhoneFeature.flags[i].enabled
        }
      }
      return false
    },
  },
  watch: {
  }
}
</script>

<style scoped>
	.list_view .result_row .entity_detail_section .title_row .title {
		cursor: pointer;
	}
	.list_view .result_row .entity_detail_section .title_row .title:hover {
		color: #b78b10;
	}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCareers.vue